import request from '@/utils/request';

const path = 'api/v1';


const incoOrderPost = data => request({
  url: `${path}/incoming/order`,
  method: 'POST',
  data,
});

const incoOrderPut = data => request({
  url: `${path}/incoming/order`,
  method: 'Put',
  data,
});

const incoOrderDelete = data => request({
  url: `${path}/incoming/order`,
  method: 'Delete',
  params: data,
});

const incoOrderList = data => request({
  url: `${path}/incoming/order`,
  method: 'Get',
  params: data,
});

const incoOrderDetailById = data => request({
  url: `${path}/incoming/order/detail`,
  method: 'Get',
  params: data,
});

const addOrderProductDetail = data => request({
  url: `${path}/incoming/order/addproduct`,
  method: 'Post',
  data,
});

const updateOrderProductDetail = data => request({
  url: `${path}/incoming/order/updateproduct`,
  method: 'Post',
  data,
});

const delOrderProductDetail = data => request({
  url: `${path}/incoming/order/delproduct`,
  method: 'Post',
  data,
});

const incoOrderCanBeFinishedGet = data => request({
  url: `${path}/canbefinished/incomingorder`,
  method: 'get',
  params: data,
});

const finishIncoOrderPut = data => request({
  url: `${path}/finish/incomingorder`,
  method: 'Put',
  data,
});

const calcelFinishIncoOrderPut = data => request({
  url: `${path}/cancelfinish/incomingorder`,
  method: 'Put',
  data,
});

export {
  incoOrderPost,
  incoOrderPut,
  incoOrderDelete,
  incoOrderList,
  incoOrderDetailById,
  addOrderProductDetail,
  updateOrderProductDetail,
  delOrderProductDetail,
  incoOrderCanBeFinishedGet,
  finishIncoOrderPut,
  calcelFinishIncoOrderPut,

};
